import moment from 'moment';

export default function formatDateSlash(date){
    return moment(date).isValid() && date ? moment(date).format("DD/MM/YYYY") : '-';
}
